import { useTranslation } from "react-i18next";
import { Typography, Layout, Row, Col } from "antd";
import "./Contact.scss";

export const Contact = () => {
    const { t } = useTranslation();
    const { Title } = Typography;
    const { Content } = Layout;

    return (
        <div className="contact">
            <Row>
                <Col span={24}>
                    <div className="main">
                        <div className="heading-parent">
                            <h2 className="header">{t("contactUs")}</h2>
                            <img className="lines" src='contact/contact-lines.png' alt="lines" />
                        </div>
                        <p className="description">{t("contactUsDesc")}</p>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="about">
                        <img className="person" src='contact/aboutSophie.png' alt="about Sophie" />
                        <div className="section-heading">
                            <h6 className="top-tag">{t("founderText")}</h6>
                            <h2 className="header">{t("founderHeading")}</h2>
                            <p className="description">{t("founderDesc")}</p>
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="about equinet">
                        <div className="section-heading">
                            <h6 className="top-tag">{t("aboutHeading")}</h6>
                            <h2 className="header">{t("aboutText")}</h2>
                            <p className="description">
                                {t("aboutDescP1")}<br />
                                {t("aboutDescP2")}<br />
                                {t("aboutDescP3")}
                            </p>
                        </div>
                        <div className="promo-img-parent">
                            <img className="promo-img" src='contact/about-promo.png' alt="promo" />
                        </div>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={24}>
                    <div className="contact-form-parent">
                        <div className="contact-form">
                            <img className="no-se" src='contact/no-se.png' alt="no-se" />
                            <h3 className="section-heading">{t("contactUs")}</h3>
                            <p className="section-desc">{t("contactUsDesc")}</p>
                            <div className="contact-details">
                                <div className="detail phone">
                                    <img src="contact/phone.png" className="contact-img phone" alt="phone" />
                                    <p>+46 702 229 499</p>
                                </div>
                                <div className="detail email">
                                    <img src="contact/email.png" className="contact-img email" alt="email" />
                                    <p>sophie@equinet.no</p>
                                </div>
                                <div className="detail location">
                                    <img src="contact/location.png" className="contact-img location" alt="location" />
                                    <p>Gamle konsgvingerveg 4, 2040 Kløfta</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
};